import { Button } from '@zorro/design-system/v2/Button';
import { Link } from '@zorro/design-system/v2/Link';
import { GuyTypingOnLaptop2 } from '@zorro/shared/assets';
import { Box, Container, Stack } from '@zorro/web/design-system';

import { StepHeading } from '../StepHeading';

export const PageNotFound = () => {
  return (
    <Container mt={{ md: '10rem' }}>
      <Stack align="center">
        <GuyTypingOnLaptop2 />

        <StepHeading
          title="Oops! We can't seem to find that page"
          subtitle="It looks like the page you're looking for doesn't exist. Check the URL, or go back to the homepage to get back on track!"
          align="center"
        />
        <Box mt="lg">
          <Link href="/" prefetch={false}>
            <Button size="lg">Home page</Button>
          </Link>
        </Box>
      </Stack>
    </Container>
  );
};
